import React from "react";
import { bool, shape, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { getStatusTagColor } from "util/discounts";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import InfoTag from "../../_components/InfoTag";
import getCellPlacement from "../../../../util/helpers/table";

const VendorDiscountsItem = ({ isDesktop, transactionsEcheqDiscount, showShareDrawer, goToTicket }) => {
    const alignX = isDesktop ? "center" : "left";
    const alignY = isDesktop ? "center" : "start";
    const getCellProps = (row, col) => ({ alignX, alignY, ...getCellPlacement(row, col, { isDesktop }) });

    return (
        <>
            <GridTable.Data {...getCellProps(1, 1)}>
                <CustomData
                    titleText="discounts.tableHeader.idBatch"
                    titleTextType="I18N"
                    valueText={transactionsEcheqDiscount?.idBatch}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data {...getCellProps(1, 2)}>
                <CustomData
                    titleText="discounts.tableHeader.applicant"
                    titleTextType="I18N"
                    valueText={transactionsEcheqDiscount?.solicitor}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data {...getCellProps(1, 3)}>
                <CustomData
                    titleText="discounts.tableHeader.issue"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={transactionsEcheqDiscount?.dateEmitted} />}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data {...getCellProps(1, 4)}>
                <CustomData
                    titleText="discounts.tableHeader.totalAmount"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount currency="ARS" quantity={transactionsEcheqDiscount?.amount?.quantity} />
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data {...getCellProps(1, 5)}>
                <CustomData
                    titleText="discounts.tableHeader.discountDiscount"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount
                            currency="ARS"
                            quantity={transactionsEcheqDiscount?.effectiveAmount?.quantity}
                        />
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 6 : 2}
                rowStart={1}
                alignX={isDesktop ? "center" : "end"}
                alignY="center">
                <InfoTag
                    type="info"
                    message={transactionsEcheqDiscount?.statusLabel}
                    tagBackground={getStatusTagColor(transactionsEcheqDiscount?.status)}
                    tagClass="discounts-echeq-tag__status"
                />
                <CustomButton
                    pullRight
                    {...{
                        icon: "images/figma/icon/menu-mobile.svg",
                        options: [
                            {
                                text: "discount.menu.view",
                                textType: "I18N",
                                func: () => goToTicket(transactionsEcheqDiscount?.idTransaction),
                            },
                            {
                                text: "discount.menu.share",
                                textType: "I18N",
                                func: () => showShareDrawer(transactionsEcheqDiscount?.idTransaction),
                            },
                        ],
                    }}
                />
            </GridTable.Data>
        </>
    );
};

VendorDiscountsItem.propTypes = {
    transactionsEcheqDiscount: shape(echeqPropTypes).isRequired,
    isDesktop: bool.isRequired,
    showShareDrawer: func.isRequired,
    goToTicket: func.isRequired,
};

export default VendorDiscountsItem;
